import { const_routes } from './const_routes';
import { fetchToken } from './fetch';

const sanitizePdfFilename = (title) => {
  const base = (title || 'documentacion-teccc')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9-_\s]/g, ' ')
    .trim()
    .replace(/\s+/g, '-')
    .toLowerCase();

  return base || 'documentacion-teccc';
};

const downloadPdfBlob = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

/** Exporta PDF vía API server (Puppeteer + Mermaid). */
export const exportDocumentationToPdfBackend = async ({
  docId,
  title,
  markdown,
  frontmatter = {},
}) => {
  if (!docId || !markdown) {
    throw new Error('docs-pdf-missing-payload');
  }

  const resp = await fetchToken(
    `${const_routes.SCHEMA}`,
    `${const_routes.VERSIONV1}`,
    `${const_routes.ROUTE_DOCUMENTATION}`,
    'export-pdf',
    { docId, title, markdown, frontmatter },
    'POST',
  );

  const contentType = resp.headers.get('content-type') || '';

  if (!resp.ok) {
    if (contentType.includes('application/json')) {
      const body = await resp.json();
      throw new Error(body.code || 'docs-pdf-generate-failed');
    }
    throw new Error('docs-pdf-generate-failed');
  }

  const arrayBuffer = await resp.arrayBuffer();
  const bytes = new Uint8Array(arrayBuffer);
  const isPdf = bytes.length > 4
    && bytes[0] === 0x25
    && bytes[1] === 0x50
    && bytes[2] === 0x44
    && bytes[3] === 0x46;

  if (!isPdf) {
    try {
      const text = new TextDecoder().decode(arrayBuffer.slice(0, 500));
      const parsed = JSON.parse(text);
      throw new Error(parsed.code || 'docs-pdf-generate-failed');
    } catch (parseError) {
      if (parseError.message?.startsWith('docs-pdf')) throw parseError;
      throw new Error('docs-pdf-invalid-response');
    }
  }

  const blob = new Blob([arrayBuffer], { type: 'application/pdf' });
  downloadPdfBlob(blob, `${sanitizePdfFilename(title || docId)}.pdf`);
};
